import request from '@/utils/request'

// 新增/修改结算单(仅基础信息)
export function settlementSaveOrUpdate(data) {
  return request({
    url: `/wms-web/purchase/settlement/saveOrUpdate` ,
    method: 'post',
    data
  })
}

//修改结算总备注
export function updatePurchaseRemarkApi(data){
  return request({
    url: `/wms-web/purchase/supplier/header/update` ,
    method: 'post',
    data
  })
}
//修改结算单价
export function updatePurchasePriceApi(data){
  return request({
    url: `/wms-web/purchase/supplier/header/detail/update/settlementUnitPrice` ,
    method: 'post',
    data
  })
}

//类型列表
export const getAssistTypeApi = (data) => {
  return request({
    url: `/wms-web/sys/select/list`,
    method: 'post',
    data
  })
}

// 保存类型
export const saveAssistTypeApi = (data) => {
  return request({
    url: `/wms-web/sys/select/saveOrUpdate`,
    method: 'post',
    data
  })
}

// 结算详情
export const getSettlementDetail = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/details`,
    method: 'post',
    data
  })
}

// 结算单确认
export const settlementConfirm = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/settlement/confirm`,
    method: 'post',
    data
  })
}

// 新增采购结算单分页查询 跨页全选
export const settlementPurchasePageSelectAll = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/purchase/pages/selected/all`,
    method: 'post',
    data
  })
}

// 结算单查询异常事件单 跨页全选
export const settlementPurchaseAbnormalPageSelectAll = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/purchase/pages/selected/all`,
    method: 'post',
    data
  })
}

// 采购单加入结算
export const purchaseSettlementAdd = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/settlement/add`,
    method: 'post',
    data
  })
}

// 供应链新增辅助结算添加
export const purchaseSettlementAssistAdd = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/assist/scm/add`,
    method: 'post',
    data
  })
}

// 异常考核加入结算单供应链
export const purchaseSettlementAbnormalAdd = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/abnormal/event/scm/add`,
    method: 'post',
    data
  })
}

// 门店新增异常添加
export const purchaseSettlementAbnormalShopAdd = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/abnormal/event/shop/add`,
    method: 'post',
    data
  })
}

// 采购单移出结算
export const purchaseSettlementRemove = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/details/remove`,
    method: 'post',
    data
  })
}

// 门店辅助结算移除
export const purchaseSettlementShopRemove = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/assist/shop/remove`,
    method: 'post',
    data
  })
}

// 新增辅助结算单
export const purchaseSettlementAddAssist = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/settlement/add/assist`,
    method: 'post',
    data
  })
}

// 结算单加入异常事件单
export const purchaseSettlementAbnormalEventAdd = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/abnormal/event/add`,
    method: 'post',
    data
  })
}

// 异常考核移除结算单供应链
export const purchaseSettlementAbnormalEventRemove = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/abnormal/event/scm/remove`,
    method: 'post',
    data
  })
}

// 门店异常移除
export const purchaseSettlementAbnormalEventShopRemove = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/abnormal/event/shop/remove`,
    method: 'post',
    data
  })
}

//发票列表
export const getSettlementData = (data,current) => {
  return request({
    url: `/wms-web/purchase/settlement/invoice/page/${current.pages}/${current.size}`,
    method: 'post',
    data
  })
}

//清空发票
export const invoiceRemoveAll = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/invoice/removeAll`,
    method: 'post',
    data
  })
}

//发票重新验真
export const resTrueApi = (data) => {
  return request({
    url: `/wms-web/`,
    method: 'post',
    data
  })
}
//发票重新推送
export const resRendApi = (data) => {
  return request({
    url: `/wms-web/`,
    method: 'post',
    data
  })
}

export const addSettlementApi = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/invoice/add`,
    method: 'post',
    data
  })
}

// 上传完成
export const purchaseUploadCompleteApi = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/invoice/upload/complete`,
    method: 'post',
    data
  })
}

//删除单据
export const delPdfApi = (data) => {
  return request({
    url: `/wms-web/purchase/settlement/invoice/remove`,
    method: 'post',
    data
  })
}

